/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import styled from '@emotion/styled/macro'; // for dom selector
import * as size from '@constant/size';
import * as color from '@constant/color';
import TextBlock from 'component/common/block/text-block';
import { formatDate, removeEmailDomain, removePrefix } from '@util/string';
import { useTypedDispatch } from '@hook/common/useStore';
import Line from '@component/common/line';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MOASHELF_PATH } from '@constant/moashelf/route-path';
import Gap from '@component/common/gap';
import { actions as newsletterActions } from '@store/slice/newsletter-slice';

interface IProps {
  articleKey: string;
  title: string;
  publishedAt: string;
  provider: string;
}

// WebProviderItemContainer와 똑같이
const WebArticleItemContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto 0 auto;
  width: 100%;
  height: 50px;
`;

const MobileArticleItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 65px;
`;

const Wrapper = styled.div`
  cursor: pointer;
  margin: 0 auto 0 auto;
`;

const MobileRowContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ArticleItem: React.FC<IProps> = ({ articleKey, title, publishedAt, provider }) => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const handleTitleClick = (shelfKey: string) => {
    navigate(`${MOASHELF_PATH.ARTICLE_PATH}/${articleKey}`);
  };

  const MOBILE_TEXT_DESIGN = {
    text: { size: 'medium', bold: true, color: color.BLACK_2 },
    box: { alignX: 'left' },
  } as const;

  const TEXT_DESIN = {
    text: { size: 'medium', color: color.BLACK_2 },
    box: { alignX: 'left' },
  } as const;

  return (
    <Wrapper>
      {IS_IYAGIGO_MOBILE_VIEW ? (
        <MobileArticleItemContainer onClick={() => handleTitleClick(articleKey)}>
          <MobileRowContainer>
            <TextBlock text={provider} design={MOBILE_TEXT_DESIGN} />
            <TextBlock
              text={formatDate(publishedAt)}
              design={{
                box: TEXT_DESIN.box,
                text: { ...TEXT_DESIN.text, size: 'tiny', bold: true },
              }}
            />
          </MobileRowContainer>
          <MobileRowContainer>
            <TextBlock
              text={removePrefix(title, '[Catch] ')}
              design={{
                text: { ...TEXT_DESIN.text, oneline: true },
                // box: { ...TEXT_DESIN.box, width: 'calc(100% - 60px)' },
                box: { ...TEXT_DESIN.box, width: 'calc(100% - 0px)' },
              }}
            />
          </MobileRowContainer>
        </MobileArticleItemContainer>
      ) : (
        <WebArticleItemContainer>
          <TextBlock
            text={removeEmailDomain(provider)}
            design={{
              box: { ...TEXT_DESIN.box, width: '120px' },
              text: { ...TEXT_DESIN.text, oneline: true },
            }}
          />
          <Gap width={size.MARGIN_1} />
          <TextBlock
            text={removePrefix(title, '[Catch] ')}
            design={{
              box: { ...TEXT_DESIN.box, width: 'calc(100% - 250px)' },
              text: { ...TEXT_DESIN.text, oneline: true },
            }}
            click={{ handler: () => handleTitleClick(articleKey) }}
          />
          <TextBlock
            text={formatDate(publishedAt)}
            design={{
              text: TEXT_DESIN.text,
              box: { ...TEXT_DESIN.box, width: '80px', alignX: 'center', margin: '0px 0px 0px auto' },
            }}
          />
        </WebArticleItemContainer>
      )}
      <Line width='100%' color={color.GRAY_3} />
    </Wrapper>
  );
};

export default ArticleItem;
